import { useState } from "react"
import { AsyncPaginate } from "react-select-async-paginate"

import { geoApiOptions, GEO_API_URL } from "../../api";

const Search = ({ onSearchChange }) => { 

    const [ search, setSearch ] = useState(null);




    
    const loadOptions = (inputValue) => {
       
        return fetch(
            `${GEO_API_URL}/cities?minPopulaion=1000000&namePrefix=${inputValue.charAt(0).toUpperCase().concat(inputValue.slice(1,inputValue.length).toLowerCase())}`,
            geoApiOptions
        )
            .then(response => response.json())
            .then((response) => {
                return { 
                    options: response.data.map((city) => {
                        return {
                            value: `${city.latitude} ${city.longitude}`,
                            label: `${city.name}, ${city.countryCode}`,
                          };
                    })
                }
            })
            
    }

    const handleOnchange = (searchData) => {

        setSearch(searchData);
        onSearchChange(searchData);

    }

    return (
        <AsyncPaginate 

            placeholder = 'Search for city'
            debounceTimeout={600}
            value={search}
            onChange={handleOnchange}
            loadOptions={loadOptions}
        />

    );
};

export default Search